var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerkauf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "20px",
    viewBox: "0 0 40 20",
    enableBackground: "new 0 0 40 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2,
    clipPath: "url(#SVGID_2_)",
    width: 28,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M34,9h3V6h-3V9z M1,16v-4h29V3h5.774C38.011,3,38,5,38,5v4l1,1v6h-2v-0.5 c0-1.381-1.119-2.5-2.5-2.5S32,14.119,32,15.5V16h-5v-0.5c0-1.381-1.119-2.5-2.5-2.5c-0.807,0-1.491,0.407-1.948,1H14v2h-1v-0.5 c0-1.381-1.119-2.5-2.5-2.5S8,14.119,8,15.5V16H7v-0.5C7,14.119,5.881,13,4.5,13S2,14.119,2,15.5V16H1z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M34.5,17.25c-0.966,0-1.75-0.784-1.75-1.75s0.784-1.75,1.75-1.75c0.967,0,1.75,0.784,1.75,1.75 S35.467,17.25,34.5,17.25"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M24.5,17.25c-0.966,0-1.75-0.784-1.75-1.75s0.784-1.75,1.75-1.75c0.967,0,1.75,0.784,1.75,1.75 S25.467,17.25,24.5,17.25"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M10.5,17.25c-0.966,0-1.75-0.784-1.75-1.75s0.784-1.75,1.75-1.75c0.967,0,1.75,0.784,1.75,1.75 S11.467,17.25,10.5,17.25"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M4.5,17.25c-0.966,0-1.75-0.784-1.75-1.75s0.784-1.75,1.75-1.75c0.967,0,1.75,0.784,1.75,1.75 S5.467,17.25,4.5,17.25"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerkauf);
export default __webpack_public_path__ + "static/media/verkauf.2a8a4a4fece719a401817a9a2960e9aa.svg";
export { ForwardRef as ReactComponent };